import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  createBookmark: function ({ siteId, activityLogId, sourceEventTime, partitionNumber }) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/bookmarks`
    let data = {
        activity_log_id: activityLogId,
        source_event_time: sourceEventTime,
        partition_number: partitionNumber
    }
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  getBookmarks: function ({ cursor, limit }) {
    let apiDetailPath = this.apiPrefix + '/user/bookmarks'
    let params = {}
    if (cursor !== undefined) params.cursor = cursor
    if (limit !== undefined) params.limit = limit

    const queryString = Object.keys(params).length > 0
      ? '?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
      : ''

    return Vue.http.get(Vue.env.apiPath + apiDetailPath + queryString, Vue.auth.getBearerHeader())
  },
  getSiteBookmarks: function ({ siteId, cursor, limit }) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/bookmarks`
    let params = {}
    if (cursor !== undefined) params.cursor = cursor
    if (limit !== undefined) params.limit = limit

    const queryString = Object.keys(params).length > 0
      ? '?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
      : ''

    return Vue.http.get(Vue.env.apiPath + apiDetailPath + queryString, Vue.auth.getBearerHeader())
  },
  deleteBookmark: function ({ siteId, bookmarkId }) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/bookmarks/${bookmarkId}`
    return Vue.http.delete(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
}
